module.exports = __webpack_public_path__ + "media/banjo.fc0ae6b8.ogg";